<div class="modal fade" bsModal #pinModal>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="Close();"><span aria-hidden="true">&times;</span></button>
          Stored Payment
        </div>
        <div class="modal-body">
          <a id="checkout-payment-modal-body"></a>
  
          <pac-payment-details *ngIf="PaymentMethods$ | async as PaymentMethods; else loading" class="pt-2"
            [Defaults]="{ cpi_preferred_flag: true }"
            [Action]="Action"
            [ShowClose]="true"
            [CustomerPaymentInfo]="CustomerPaymentInfo"
            [PaymentMethods]="PaymentMethods"
            (BeforeSave)="OnBeforeSave($event)"
            (AfterSave)="OnAfterSave($event)"
            (Error)="OnError($event)"
            (Close)="Close()"
            (Busy$)="Busy$.next($event)"
            >
            <p slot="apm-readonly" class="small form-text text-muted">You cannot change the payment
              method on existing entries. If you need to change the payment method, please add a new card.</p>
          </pac-payment-details>
  
          <ng-template #loading>
            <p>Loading payment method...</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>